import React, { useState, useEffect, forwardRef } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import TermAndConditionContent from './TermAndConditionContent';

const ModalTermsCondition = forwardRef((props, ref) => {
    return (
        <React.Fragment>
            <Modal isOpen={props.modal} toggle={props.toggle} className="modal-dialog-centered modal-lg" backdrop={props.backdrop}>
                <ModalHeader toggle={props.toggle}><i className="app-menu__icon fa fa-user mr-2"></i> {props.title}</ModalHeader>
                <ModalBody className='terms-condition-modal-body pt-0'>
                    <TermAndConditionContent />
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
});


export default ModalTermsCondition;
